import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center gap-5 px-4 text-center">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,hsl(var(--primary)/0.08),transparent_60%)]"
      />
      <div className="relative">
        <div
          className="font-display text-7xl font-semibold tracking-tighter text-primary/40"
          aria-hidden
        >
          404
        </div>
        <div className="-mt-2 flex justify-center">
          <Logo size={1.1} />
        </div>
      </div>
      <h1 className="relative text-2xl font-semibold">{t("not_found.title")}</h1>
      <p className="relative max-w-md text-muted-foreground">{t("not_found.description")}</p>
      <Button asChild className="relative">
        <Link to="/">{t("not_found.back_home")}</Link>
      </Button>
    </div>
  );
}
